import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../shared/core2Config';
import { FiMstCategoryLevelSettingsModel } from '../../../../../models/aggregates/fi-mst-category-level-settings';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';

@Injectable({
  providedIn: 'root'
})
export class FiMstCategoryLevelSettingsService extends BaseApiPublicLoginTemplateService<FiMstCategoryLevelSettingsModel,FiMstCategoryLevelSettingsModel,FiMstCategoryLevelSettingsModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'category-level-setting-hdrs/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.INV_PREFIX + 'category-level-setting-hdrs/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }
}